import s from './RouteLoadingBar.module.scss';

export const RouteLoadingBar = () => {
  'use memo';

  return <div className={s.routeLoadingBar} />;
};
